/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



/**
 * Insurance-related constant identifiers.
 * 
 * These constants are used to identify special placeholder values for insurance
 * when a patient has no insurance coverage.
 */

/**
 * Identifier for "No Insurance" option in autocomplete dropdowns.
 * This is the user-facing selection value.
 */
export const NO_INSURANCE_ID = "NO_INSURANCE";

/**
 * Identifier for "No Insurance" placeholder in PatientInsuranceInterface objects.
 * This is the internal data structure identifier.
 */
export const NO_INSURANCE_OPTION_ID = "NO_INSURANCE_OPTION";
